import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 1,
  class: "fas fa-calendar-times me-2"
}


export default {
  __name: 'BookingConflictActions',
  props: {
	selectedResolution: { type: String, default: "" },
	isLoading: { type: Boolean, default: false },
	isSeriesBooking: { type: Boolean, default: false },
},
  emits: ["cancel", "back", "resolve"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx, _cache) => {
  return (__props.selectedResolution === 'change-config')
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn btn-info",
        disabled: __props.isLoading,
        onClick: _cache[0] || (_cache[0] = $event => (emit('back')))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString(__props.isSeriesBooking ? "Konfiguration ändern" : "Buchung ändern"), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "btn btn-primary",
        disabled: __props.isLoading || !__props.selectedResolution,
        onClick: _cache[1] || (_cache[1] = $event => (emit('resolve')))
      }, [
        (__props.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : (_openBlock(), _createElementBlock("i", _hoisted_4)),
        _createTextVNode(" " + _toDisplayString(__props.isSeriesBooking ? "Ausfalltermine hinzufügen" : "Buchung ändern"), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_2))
}
}

}